function onlyNumeric(value) {
  return +[...value.toString()].map(letter => Number.isNaN(parseInt(letter)) ? "" : letter).join("");
}

export default onlyNumeric;